module.exports = __webpack_public_path__ + "img/image_middle_condition2_d@2x.2f671a90.png";